import React from 'react';

export default function SmallLogoSvg({fill}) {
  return (
    <svg width="31" height="29" viewBox="0 0 31 29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 29V8.4878L15.5 0L31 8.4878V29H0Z" fill={fill} />
    </svg>
  );
}
